import React from 'react';

export const Button = ({onPress, text}) => {
  return (
      <button type={'button'} onClick={onPress} className={'buttonStyle'}>
          {text}
      </button>
  )
};